import React from 'react';
import 'whatwg-fetch';
import InputUpdate from '../input/inputUpdate';
import SubNavBar from '../SubNavBar';
import withAuth from 'src/hoc/withAuth';

const apiGooglePlacesKey = 'AIzaSyDRlXkY2RLj_iPBmaZwyKAS0HjNtsPx6LQ';
const apiSociete = 'http://www.societe.com/cgi-bin/search?champs=';
const apiCustomerShow = '/api/customer/show/';
var createReactClass = require('create-react-class');

class DisplayCustomerSite extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fatalError: undefined,
      isModalPostDealOpen: false,
      entity: undefined,
      customerId: undefined,
      customerInstallationName: '____',
      customerInstallationAddress: '____',
      customerInstallationCity: '____',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateField = this.updateField.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.setState({ fatalError: undefined });

      // check if id supplied in the route
      const paramsID = this.props.match.params.id;

      let queryURL = apiCustomerShow;
      let graphQL =
        '{ customer(id:' +
        paramsID +
        '){ id, installationSite{ socialReason, siret, adress, postalCode, telOffice, telFax }, billingSite{ socialReason, siret, adress, postalCode, telOffice, telFax } } }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then((data) => {
          if (data['data']['customer']) {
            this.setState({
              entity: data['data']['customer'],
              customerId: data['data']['customer']['id'],
              customerInstallationName: data['data']['customer']['installationSite']['socialReason'],
              customerInstallationSiret: data['data']['customer']['installationSite']['siret'],
              customerInstallationAddress: data['data']['customer']['installationSite']['adress'],
              customerInstallationCity: data['data']['customer']['installationSite']['postalCode'],
              customerInstallationTelOffice: data['data']['customer']['installationSite']['telOffice'],
              customerInstallationTelFax: data['data']['customer']['installationSite']['telFax'],
            });
            if (data['data']['customer']['billingSite']) {
              this.setState({
                customerBillingName: data['data']['customer']['billingSite']['socialReason'],
                customerBillingSiret: data['data']['customer']['billingSite']['siret'],
                customerBillingAddress: data['data']['customer']['billingSite']['adress'],
                customerBillingCity: data['data']['customer']['billingSite']['postalCode'],
                customerBillingTelOffice: data['data']['customer']['billingSite']['telOffice'],
                customerBillingTelFax: data['data']['customer']['billingSite']['telFax'],
              });
            }
          } else {
            let message = 'Erreur lors de la récupération du client';

            if (data['errors'] && data['errors'].length > 0) {
              message = data['errors'].map((e) => e.message).join(', ');
            }

            throw new Error(message);
          }
        })
        .catch((error) => {
          this.setState({ fatalError: error.message });
        });
    }
    ///////////////////////////////////////
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      // Route reloaded
      this.componentDidMount();
    }
  }

  convertAddressToGMap(address, city) {
    return address.replace(' ', '+') + ',' + city.replace(' ', '+');
  }

  render() {
    const GMaps = createReactClass({
      iframe: function () {
        return {
          __html:
            '<iframe src="https://www.google.com/maps/embed/v1/place?key=' +
            apiGooglePlacesKey +
            '&q=' +
            this.props.address +
            '"></iframe>',
        };
      },

      render: function () {
        return <div className={'component-gmap'} dangerouslySetInnerHTML={this.iframe()} />;
      },
    });

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar
          actionButton={
            <a href={apiSociete + this.state.customerInstallationName.replace(/\s/g, '+')} target='_blank'>
              <button type='button' className='btn btn-sm btn-outline-success'>
                Infos Societe
              </button>
            </a>
          }
          goBack={this.props.history.goBack}
          title='Site Client'
        />

        <div id='appViewContent'>
          {!this.state.fatalError ? (
            <div className='entity-display'>
              {this.state.customerInstallationAddress && (
                <div>
                  <div className='alignHorizontal'>
                    <h3>Site d'installation {!this.state.customerBillingAddress && '& facturation'}</h3>
                  </div>

                  <br />

                  <form>
                    <InputUpdate
                      inputType={'text'}
                      inputLabel={'Raison sociale'}
                      inputValue={this.state.customerInstallationName}
                      submitUpdate={(inputValue) =>
                        this.updateField(inputValue, 'text', 'installationSite.socialReason')
                      }
                      toggleBlackOut={() => this.props.toggleBlackOut()}
                    />
                    <InputUpdate
                      inputType={'text'}
                      inputLabel={'Siret'}
                      inputValue={this.state.customerInstallationSiret}
                      submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'installationSite.siret')}
                      toggleBlackOut={() => this.props.toggleBlackOut()}
                    />
                    <InputUpdate
                      inputType={'text'}
                      inputLabel={'Adresse'}
                      inputValue={this.state.customerInstallationAddress}
                      submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'installationSite.adress')}
                      toggleBlackOut={() => this.props.toggleBlackOut()}
                    />
                    <InputUpdate
                      inputType={'text'}
                      inputLabel={'Code postal / Ville'}
                      inputValue={this.state.customerInstallationCity}
                      submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'installationSite.postalCode')}
                      toggleBlackOut={() => this.props.toggleBlackOut()}
                    />
                    <InputUpdate
                      inputType={'text'}
                      inputLabel={'Téléphone'}
                      inputValue={this.state.customerInstallationTelOffice}
                      submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'installationSite.telOffice')}
                      toggleBlackOut={() => this.props.toggleBlackOut()}
                    />
                    <InputUpdate
                      inputType={'text'}
                      inputLabel={'Fax'}
                      inputValue={this.state.customerInstallationTelFax}
                      submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'installationSite.telFax')}
                      toggleBlackOut={() => this.props.toggleBlackOut()}
                    />
                  </form>
                  <GMaps
                    address={this.convertAddressToGMap(
                      this.state.customerInstallationAddress,
                      this.state.customerInstallationCity
                    )}
                  />
                </div>
              )}

              {this.state.customerBillingAddress && (
                <div>
                  <br />
                  <div className='alignHorizontal'>
                    <h3>Site de facturation</h3>
                  </div>

                  <br />

                  <form>
                    <InputUpdate
                      inputType={'text'}
                      inputLabel={'Raison sociale'}
                      inputValue={this.state.customerBillingName}
                      submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'billingSite.socialReason')}
                      toggleBlackOut={() => this.props.toggleBlackOut()}
                    />
                    <InputUpdate
                      inputType={'text'}
                      inputLabel={'Siret'}
                      inputValue={this.state.customerBillingSiret}
                      submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'billingSite.siret')}
                      toggleBlackOut={() => this.props.toggleBlackOut()}
                    />
                    <InputUpdate
                      inputType={'text'}
                      inputLabel={'Adresse'}
                      inputValue={this.state.customerBillingAddress}
                      submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'billingSite.adress')}
                      toggleBlackOut={() => this.props.toggleBlackOut()}
                    />
                    <InputUpdate
                      inputType={'text'}
                      inputLabel={'Code postal / Ville'}
                      inputValue={this.state.customerBillingCity}
                      submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'billingSite.postalCode')}
                      toggleBlackOut={() => this.props.toggleBlackOut()}
                    />
                    <InputUpdate
                      inputType={'text'}
                      inputLabel={'Téléphone'}
                      inputValue={this.state.customerBillingTelOffice}
                      submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'billingSite.telOffice')}
                      toggleBlackOut={() => this.props.toggleBlackOut()}
                    />
                    <InputUpdate
                      inputType={'text'}
                      inputLabel={'Fax'}
                      inputValue={this.state.customerBillingTelFax}
                      submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'billingSite.telFax')}
                      toggleBlackOut={() => this.props.toggleBlackOut()}
                    />
                  </form>
                  <GMaps
                    address={this.convertAddressToGMap(
                      this.state.customerBillingAddress,
                      this.state.customerBillingCity
                    )}
                  />
                </div>
              )}
            </div>
          ) : (
            <div className='alert alert-danger' role='alert'>
              {this.state.fatalError}
            </div>
          )}
        </div>
      </div>
    );
  }

  updateField(newValue, inputType, fieldName) {
    // !! Important-> the given "fieldName" attribute must be the name of the ORM attribute !!
    let newValueSent;
    if (inputType == 'text') {
      newValueSent = '"' + newValue.replace(/["]/g, '\\"') + '"';
    } else {
      newValueSent = newValue;
    }

    let params = fieldName.split('.');

    let graphQL = 'mutation { customer(id:' + this.props.match.params.id + ', ';
    graphQL += params[0] + ':{' + params[1] + ':' + newValueSent + '}) { ' + params[0] + '{' + params[1] + '} } }';

    let queryURL = apiCustomerShow;
    let data = 'data=' + encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['data']['customer'][params[0]][params[1]] == newValue) {
          this.props.openToast(true, 'Votre modification a bien été prise en compte.');
          this.componentDidMount();
        } else {
          this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
        }
      })
      .catch(() => {
        console.log('erreur fetch UPDATE customer entity');
      });
  }
}

export default withAuth(DisplayCustomerSite);
